(function (scope) {

scope.HeroBanner = function () {
	var me = this;
	var headerHeight = $(".page").offset ().top;
	if ($(".donor-box-embed").length) headerHeight = 0;
	$(window).on ("scroll.HeroBanner", function () {
		$(".hero-banner-item .image, .in-page-banner-item .image").each (function () {
			var img = $(this);
			var rect = this.getBoundingClientRect ();
			if (rect.y < headerHeight) {
				//push this down
				img.data ("is-parallaxed", true);
/*				img.css ({
					transform: "translate(0," + Math.abs (headerHeight - rect.y) / 2 + "px)"
				});
*/			} else if (rect.y + rect.height > window.innerHeight) {
				//push this up
				img.data ("is-parallaxed", true);
/*				img.css ({
					transform: "translate(0," + Math.abs (rect.y + rect.height - window.innerHeight) / -2 + "px)"
				});
*/			} else if (img.data ("is-parallaxed")) {
				img.data ("is-parallaxed", false);
/*				img.css ({
					transform: "translate(0,0)"
				});
*/			}
		});
	});
};

}) (window);
